export const HEADER_NGINX_COUNTRY = 'x-bm-country'
export const HEADER_CFWORKER_COUNTRY = 'bm-country'
